export type Conversation = {
	id: string;
	lead: string;
	contact: string;
	when: string;
	whenAbs: string;
	preview: string;
	messages: number;
	live?: boolean;
};

/**
 * v1 seed data for the AI Conversations popout. In production this comes from
 * an AI-conversation-history endpoint; the popout component stays pure and the
 * composition root chooses the source. Ordered newest first.
 */
export const seedConversations: Conversation[] = [
	{
		id: 'c1',
		lead: 'Levitate',
		contact: 'Jes Lipson',
		when: 'Just now',
		whenAbs: 'Today · 12:05 PM',
		preview: "Hey Jes, it's Patrick — before we dig into Clio, mind if I steal two minutes on foreclosure intake?",
		messages: 8,
		live: true,
	},
	{
		id: 'c2',
		lead: 'Hartwell Legal Group',
		contact: 'Maren Ortiz',
		when: '2h ago',
		whenAbs: 'Today · 10:14 AM',
		preview: "Battle card — they're evaluating Lawmatics. Lead with Clio 2-way sync and the Success Specialist model.",
		messages: 14,
	},
	{
		id: 'c3',
		lead: 'Fairmont & Yang',
		contact: 'David Yang',
		when: 'Yesterday',
		whenAbs: 'Apr 21 · 4:42 PM',
		preview: 'Recap — David pushed back on seat pricing. Open: proposal with 10 seats + 2 free for 90 days.',
		messages: 22,
	},
	{
		id: 'c4',
		lead: 'Northstar Defense',
		contact: 'Priya Raman',
		when: 'Yesterday',
		whenAbs: 'Apr 21 · 11:08 AM',
		preview: 'Discovery — 60 matters/mo, one paralegal drowning. Strong fit for AI drafting + SMS campaigns.',
		messages: 11,
	},
	{
		id: 'c5',
		lead: 'Coastal Bankruptcy Co.',
		contact: 'Elena Ruiz',
		when: 'Mon',
		whenAbs: 'Apr 20 · 2:30 PM',
		preview: "Objection handler — 'we already use Mailchimp.' Angle: legal-specific templates + compliance posture.",
		messages: 9,
	},
	{
		id: 'c6',
		lead: 'Levitate',
		contact: 'Jes Lipson',
		when: 'Mar 28',
		whenAbs: 'Mar 28 · 3:15 PM',
		preview: 'ShareFile gap — Brayan pushed back on the Dropbox alternative. Follow up with the integration roadmap.',
		messages: 18,
	},
	{
		id: 'c7',
		lead: 'Mesa Immigration Law',
		contact: 'Carlos Vega',
		when: 'Mar 22',
		whenAbs: 'Mar 22 · 9:50 AM',
		preview: 'Game plan — Spanish-language templates are the hook. Push for a pilot with the intake team first.',
		messages: 16,
	},
];
